import { styled, alpha } from '@ori-ui/mui';

import { centeredFlexStyles } from '../../constants';
import type { LoadingOverlayProps } from './types';

export const Root = styled('div')<{ ownerState: LoadingOverlayProps }>(
  ({ ownerState: { isBasketSharingEnabled }, theme }) => ({
    ...centeredFlexStyles,
    position: 'absolute',
    top: theme.spacing(13),
    bottom: theme.spacing(9),
    width: '100%',
    height: `calc(100% - ${theme.spacing(28 + (isBasketSharingEnabled ? 11 : 0))})`, // 100% - (header + footer height)
    background: alpha(theme.palette.common.white, 0.5),
    zIndex: 999,
  }),
);
